import * as React from 'react';
import {Checkbox as SemanticCheckBox} from "semantic-ui-react";
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";

interface CheckBoxProps extends IVirtualizedTableCellComponentProps {

}

const CheckBox: React.SFC<CheckBoxProps> = (props) => {
    return (
        <SemanticCheckBox
            checked={props.value}
            onChange={(e,data) => {
                if(data) {
                    props.onChange(data.checked);
                } else {
                    props.onChange(e.currentTarget.checked);
                }

            }}
            disabled={props.readOnly}
            toggle={props.toggle}
        />);
};

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/CheckBox.tsx